export default __webpack_public_path__ + "static/mar-int-auto-b0211d48bd66666656a6f32954f64619.png";